import { all } from 'redux-saga/effects';

import assinaturaSaga from './saga_assinatura';
import configuracoesSaga from './saga_configuracoes';
import enderecoSaga from './saga_endereco';
import formulariosSaga from './saga_formularios';
import servicosSaga from './saga_servicos';
import solicitacoesSaga from './saga_solicitacoes';
import usuarioSaga from './saga_usuario';
import usuarioLinkSaga from '../modules/linkUser/saga';
import usuarioPerfilSaga from '../modules/perfilUsuario/saga';
import visitanteSaga from './saga_visitante';
import notificationsBadgeSaga from 'App/AppLayout/containers/NotificationBadge/store/saga';
import notificationsSaga from 'App/Notifications/store/saga';
import itemMenuSaga from './saga_itemMenu';

export default function* watchMany() {
	yield all([
		assinaturaSaga(),
		configuracoesSaga(),
		enderecoSaga(),
		formulariosSaga(),
		servicosSaga(),
		solicitacoesSaga(),
		usuarioSaga(),
		visitanteSaga(),
		notificationsBadgeSaga(),
		notificationsSaga(),
		itemMenuSaga(),
		usuarioLinkSaga(),
		usuarioPerfilSaga()
	]);
}
